<template>
  <div class="centralScheduling">
    <div v-if="eventInfo.currentLink === 6 && curRole === '市中心管理人员'">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
        <FormItem label="区县请求支援详情">
          <span>{{ formValidate.methodPlan }}</span>
        </FormItem>
        <FormItem label="调动队伍">
          <div style="text-align: right">
            <Button type="primary" size="small" @click="teamAssign">调派</Button>
          </div>
          <Table
            size="small"
            :loading="teamLoading"
            :columns="teamColumns"
            :data="teamData"
            :border="false"
            :stripe="false"
            :highlight-current-row="true"
          >
            <template #action="{ row, index }">
              <el-button size="small" type="text" @click="deleteSelTeam(row,index)">删除</el-button>
            </template>
          </Table>
          <!--          <el-button size="small" type="text" @click="saveTeam">提交</el-button>-->
        </FormItem>
        <FormItem label="调动物资">
          <div style="text-align: right">
            <Button type="primary" size="small" @click="resourceAssign">调派</Button>
          </div>
          <Table
            size="small"
            :loading="resouLoading"
            :columns="resouColumns"
            :data="resouData"
            :border="false"
            :stripe="false"
            :highlight-current-row="true"
          >
            <template slot="invokeGoodsNums" slot-scope="{ row, index }">
              <el-input-number v-if="!row.invokeGoodsRecord" v-model="resouData[index]['invokeGoodsNums']" size="small"
                               :min="0"></el-input-number>
              <span v-else>{{ resouData[index]['invokeGoodsRecord']['invokeGoodsNums'] }}</span>
            </template>
            <template #action="{ row, index }">
              <el-button size="small" type="text" @click="deleteSelResource(row,index)">删除</el-button>
            </template>
          </Table>
          <!--          <el-button size="small" type="text" @click="saveResource">提交</el-button>-->
        </FormItem>
      </Form>

      <div style="text-align: center">
        <!--      <Button type="primary" @click="">是否请求支援</Button>-->
        <Button type="primary" @click="handleSubmit('formValidate')">提交
        </Button>
        <Button @click="handleReset('formValidate')" style="margin-left: 8px">
          重置
        </Button>
      </div>
    </div>

    <div v-else-if="formValidate.sendingMethod === '1'">
      <el-descriptions class="margin-top" size="medium" :column="1" border
                       :labelStyle="{'text-align': 'center','width':'20%','color':'#555'}">
        <el-descriptions-item label="区县支援请求">
          {{ formValidate.methodPlan }}
        </el-descriptions-item>
        <el-descriptions-item label="调动队伍">
          <Table
            size="small"
            :loading="teamLoading"
            :columns="teamColumns"
            :data="teamData"
            :border="false"
            :stripe="false"
            :highlight-current-row="true"
          >
            <template #action="{ row, index }">
            </template>
          </Table>
        </el-descriptions-item>
        <el-descriptions-item label="调动物资">
          <Table
            size="small"
            :loading="resouLoading"
            :columns="resouColumns"
            :data="resouData"
            :border="false"
            :stripe="false"
            :highlight-current-row="true"
          >
            <template slot="invokeGoodsNums" slot-scope="{ row, index }">
              <span>{{ resouData[index]['invokeGoodsNums'] }}</span>
            </template>
            <template #action="{ row, index }">
            </template>
          </Table>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div v-else>此事件未请求支援</div>
    <Modal
      v-model="teamModal"
      title="调派队伍"
      :mask-closable="false"
      @on-ok="okTeam"
      :width="60"
      @on-cancel="cancelTeam"
      :styles="{top: '10%'}"
    >
      <Table
        size="small"
        ref="selection"
        :loading="teamCanLoading"
        :columns="teamCanColumns"
        :data="teamCanData"
        :border="false"
        :stripe="false"
        :highlight-current-row="true"
        @on-selection-change="selectTeam"
      ></Table>
      <Page style="text-align: right;margin-top: 10px"
            show-sizer
            show-total
            transfer
            :total="dataTotalTeamCan"
            :page-size="pageSizeTeamCan"
            :page-size-opts="pageSizeOptsTeamCan"
            :current-page="currentPageTeamCan"
            @on-change="pageChangeTeamCan"
            @on-page-size-change="pageSizeChangeTeamCan"
      ></Page>
    </Modal>

    <Modal
      v-model="resouModal"
      title="调派物资"
      :mask-closable="false"
      @on-ok="okResource"
      @on-cancel="cancelResource"
      :styles="{top: '0px'}"
    >
      <Row style="margin-bottom: 10px">
        <Col :span="4"><span>选择仓库：</span></Col>
        <Col :span="20">
          <Select
            v-model="selBase"
            filterable
            clearable
            :remote-method="remoteMethod"
            :loading="selBaseLoading"
            @on-change="getEmergencyResource"
            @on-clear="getEmergencyBase"
          >
            <Option v-for="(option, index) in baseList" :value="option.value" :key="index">{{ option.label }}</Option>
          </Select>
        </Col>
      </Row>
      <Table
        size="small"
        ref="selection"
        :loading="resouCanLoading"
        :columns="resouCanColumns"
        :data="resouCanData"
        :border="false"
        :stripe="false"
        :highlight-current-row="true"
        @on-selection-change="selectResource"
      >
        <!--        <template #action="{ row, index }">-->
        <!--          <el-button size="small" type="text" @click="">是否支援</el-button>-->
        <!--        </template>-->
      </Table>
      <!--      <Page style="text-align: right;margin-top: 10px"-->
      <!--            show-sizer-->
      <!--            show-total-->
      <!--            transfer-->
      <!--            :total="dataTotalResCan"-->
      <!--            :page-size="pageSizeResCan"-->
      <!--            :page-size-opts="pageSizeOptsResCan"-->
      <!--            :current-page="currentPageResCan"-->
      <!--            @on-change="pageChangeResCan"-->
      <!--            @on-page-size-change="pageSizeChangeResCan"-->
      <!--      ></Page>-->
    </Modal>
  </div>
</template>

<script>
export default {
  name: "centralScheduling",
  props: {
    eventInfo: {
      type: Object,
      default: () => {
      }
    },
    stepInfo: {
      type: String,
      default: ''
    },
    preStep: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      planList: [],
      selTeam: [],
      selBase: '',
      selBaseLoading: false,
      baseList: [],
      selResource: [],
      teamLoading: false,
      teamColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '队长',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.dz)
          }
        },
        {
          title: '职责',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.duty)
          },
        },
        {
          title: '人员',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.teamPart)
          },
        }
      ],
      teamData: [],
      teamModal: false,
      teamCanLoading: false,
      teamCanColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '队长',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.dz)
          }
        },
        {
          title: '职责',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.duty)
          },
        },
        {
          title: '人员',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.teamPart)
          },
        }
      ],
      teamCanData: [],
      resouLoading: false,
      resouColumns: [
        {
          title: '物资名称',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.name)
          }
        },
        {
          title: '数量',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, `${params.row.number}${params.row.unit}`)
          },
        },
        {
          title: '调派数量',
          align: 'center',
          width: '150',
          slot: 'invokeGoodsNums'
        },
        {
          width: '100',
          title: '操作',
          // fixed: 'right',
          align: 'center',
          slot: 'action',
        }
      ],
      resouData: [],
      resouModal: false,
      resouCanLoading: false,
      resouCanColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '物资名称',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.name)
          }
        },
        {
          title: '数量',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, `${params.row.number}${params.row.unit}`)
          },
        },
      ],
      resouCanData: [],
      formValidate: {
        choosePlan: '',
        disposalPlan: '',
        sendingMethod: '0',
        methodPlan: ''
      },
      ruleValidate: {},
      dataTotalTeamCan: 0,
      pageSizeTeamCan: 10,
      pageSizeOptsTeamCan: [10, 20, 30, 40],
      currentPageTeamCan: 1,
      dataTotalResCan: 0,
      pageSizeResCan: 10,
      pageSizeOptsResCan: [10, 20, 30, 40],
      currentPageResCan: 1,
      curRole: ''
    }
  },
  mounted() {
    this.getUserData()
    // this.getPlanList()
    this.getEmergencyTeams()
    this.getEmergencyBase()
    console.log(this.stepInfo)
    // console.log(this.preStep)
    this.formatInfo(this.preStep)
    if (this.stepInfo !== '' && this.stepInfo !== null) {
      this.formatInfo(this.stepInfo)
    }
  },
  methods: {
    getUserData() {
      this.$http.get('/api/system/cscpCurrentUserDetails').then(res => {
        console.log(res)
        if (res.status === 200) {
          this.curRole = res.data.roleNames
        }
      })
    },
    formatInfo(information) {
      // console.log(information)
      let info = information.split(';')
      // console.log(info)
      info.forEach(item => {
        const obj = item.split('_')
        this.formValidate[obj[0]] = obj[1]
        if (obj[0] === 'cdispatchTeam') {
          const list = JSON.parse(obj[1])
          this.teamData = list
        }
        if (obj[0] === 'cdispatchResource') {
          const list = JSON.parse(obj[1])
          this.resouData = list
        }
      })
    },
    // 获取预案
    getPlanList() {
      let params = {}
      this.$http.post('/api/getPlanList', params).then(res => {
        // console.log(res)
        this.planList = res.data.data
      })
    },
    formatTeam() {
      this.teamData = this.teamData.map(item => {
        let team = {
          id: item.id,
          name: item.name
        }
        return team
      })
    },
    formatGood() {
      this.resouData = this.resouData.map(item => {
        let good = {
          id: item.id,
          name: item.name,
          number: item.number,
          unit: item.unit,
          invokeGoodsNums: item.invokeGoodsNums
        }
        return good
      })
    },
    // 调派队伍
    getEmergencyTeams(status) {
      this.teamCanLoading = true
      let params = {
        status: status
      }
      this.$http.get(`/api/getEnableTeamsList?page=${this.currentPageTeamCan}&&size=${this.pageSizeTeamCan}`).then(res => {
        // console.log(res)
        if (status === 1) {
          this.teamData = res.data.data.list
        } else {
          let oldTeam = this.teamData
          this.teamCanData = res.data.data
          console.log('this.teamCanData', this.teamCanData)
          this.dataTotalTeamCan = res.data.recordsTotal
          this.teamCanLoading = false
          // 默认选中
          if (this.teamCanData) {
            this.teamCanData.forEach(item => {
              oldTeam.forEach(old => {
                if (item.fId === old.fId) {
                  item._checked = true
                }
              })
            })
          }
        }
      })
    },
    // 保存调派队伍
    saveTeam() {
      let params = []
      this.teamData.forEach(item => {
        const param = {
          invokeAreaIndexCode: item.emergencyTeam.responsibleAreaId,
          invokeTeamId: item.emergencyTeam.id,
          supportEventId: this.eventInfo.id
        }
        params.push(param)
      })
      console.log(params)
      this.$http.post('/api/team/invokeTeam', params).then(res => {
        console.log(res)
        this.getInvokeTeams()
      })
    },
    // 获取调派队伍
    getInvokeTeams() {
      this.teamCanLoading = true
      let params = {
        endTime: "",
        eventId: this.eventInfo.id,
        startTime: "",
        teamIds: []
      }
      this.$http.post('/api/invokeTeam/getRecords ', params).then(res => {
        console.log(res)
        // this.teamCanData = res.data.data.list
        // this.dataTotalTeamCan = res.data.data.total
        // this.teamCanLoading = false
      })
    },
    teamAssign() {
      this.teamModal = true
      this.getEmergencyTeams(0)
    },
    selectTeam(selection, row) {
      console.log(selection, row)
      this.selTeam = selection
    },
    selectTeamCancel(selection, row) {
      // console.log(selection, row)
      this.selTeam = selection
    },
    okTeam() {
      this.teamModal = false
      this.teamData = this.selTeam
      this.formatTeam()
      // 保存调派队伍
      // let params = []
      // this.selTeam.forEach(item => {
      //   const param = {
      //     invokeAreaIndexCode: item.emergencyTeam.responsibleAreaId,
      //     invokeTeamId: item.emergencyTeam.id,
      //     supportEventId: this.eventInfo.id
      //   }
      //   params.push(param)
      // })
      // this.saveTeam(params)
    },
    cancelTeam() {
      this.teamModal = false
      // this.selTeam = []
      this.getInvokeTeams()
    },
    // 获取仓库
    getEmergencyBase() {
      this.selBaseLoading = true
      let params = {
        storeHouseType: '',
        name: '',
        responsibleAreaId: ''
      }
      this.$http.post('/api/storehouse/getAll', params).then(res => {
        // console.log(res)
        this.options = res.data.data.list
        this.baseList = this.options.map(item => {
          return {
            value: item.storeHouse.id,
            label: item.storeHouse.name,
          };
        });
        this.selBaseLoading = false
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.selBaseLoading = true;
        setTimeout(() => {
          this.selBaseLoading = false;
          const list = this.options.map(item => {
            return {
              value: item.storeHouse.id,
              label: item.storeHouse.name,
            };
          });
          this.baseList = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
        }, 200);
      } else {
        this.baseList = [];
      }
    },
    // 获取物资
    getEmergencyResource() {
      // this.dataLoading = true
      if (this.selBase) {
        this.$http.get(`/api/goods/getGoods/${this.selBase}`).then(res => {
          // console.log(res)
          this.resouCanData = res.data.data
          // this.data = res.data.data.list
          // this.dataTotal = res.data.data.total
          // this.dataLoading = false
        })
      } else {
        this.resouCanData = []
      }
    },
    // 保存调派物资
    saveResource() {
      let params = []
      this.resouData.forEach(item => {
        const param = {
          // invokeAreaIndexCode: item.storeHouse.responsibleAreaId,
          belongStoreId: this.selBase,
          invokeGoodsId: item.id,
          invokeGoodsNums: item.invokeGoodsNums,
          supportEventId: this.eventInfo.id
        }
        params.push(param)
      })
      console.log(params)
      this.$http.post('/api/goods/invokeGoods', params).then(res => {
        console.log(res)
        this.getInvokeResource()
      })
    },
    // 获取调派物资
    getInvokeResource() {
      this.teamCanLoading = true
      let params = {
        endTime: "",
        eventId: this.eventInfo.id,
        startTime: "",
        teamIds: []
      }
      this.$http.post('/api/invokeGoods/getRecords', params).then(res => {
        console.log(res)
        // this.resouData = res.data.data.list
        // this.dataTotalTeamCan = res.data.data.total
        // this.teamCanLoading = false
      })
    },
    resourceAssign() {
      this.resouModal = true
      this.getEmergencyBase()
    },
    selectResource(selection, row) {
      // console.log(selection, row)
      this.selResource = selection
    },
    selectResourceCancel(selection, row) {
      this.selResource = selection
    },
    okResource() {
      this.resouModal = false
      this.resouData = [...this.resouData, ...this.selResource]
      this.formatGood()
    },
    cancelResource() {
      this.resouModal = false
      this.resouData = [...this.resouData, ...this.selResource]
      this.getInvokeResource()
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveTeam()
          this.saveResource()
          const dispatchTeam = JSON.stringify(this.teamData)
          const dispatchResource = JSON.stringify(this.resouData)
          let params = {
            currentLink: this.eventInfo.currentLink,
            indexCode: this.eventInfo.deptIndexCode,
            information: `methodPlan_${this.formValidate.methodPlan};cdispatchTeam_${dispatchTeam};cdispatchResource_${dispatchResource}`,
            messageId: this.eventInfo.id
          }
          console.log(params)
          // if (this.formValidate.sendingMethod === '1') {
          //   this.$http.post('/api/jumpPreLink', params).then(res => {
          //     console.log(res)
          //     this.$emit('refreshStep')
          //   })
          // } else {
          this.$http.post('/api/jumpNextLink', params).then(res => {
            console.log(res)
            this.$emit('refreshStep')
          })
          // }
          this.$Message.success('提交成功!');
        } else {
          this.$Message.error('请填写!');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    pageChangeTeamCan(page) {
      this.currentPageTeamCan = page
      this.getEmergencyTeams()
    },
    pageSizeChangeTeamCan(pageSize) {
      this.pageSizeTeamCan = pageSize
      this.getEmergencyTeams()
    },
    pageChangeResCan(page) {
      this.currentPageTeamCan = page
      this.getEmergencyResource()
    },
    pageSizeChangeResCan(pageSize) {
      this.pageSizeTeamCan = pageSize
      this.getEmergencyResource()
    },
    deleteSelTeam(row, index) {
      this.teamData.splice(index, 1)
      // this.selTeam = this.teamData
    },
    deleteSelResource(row, index) {
      this.resouData.splice(index, 1)
      this.selResource = this.selResource
    },
  }
}
</script>

<style scoped lang="less">
.centralScheduling {
  width: 60%;
  margin: 0 auto;
}
</style>
